export type IndexerAsset = string | { mint?: string; asset?: string } | null;

export function appendIndexerAsset(
  params: URLSearchParams,
  indexerAsset?: IndexerAsset
): void {
  if (!indexerAsset) return;

  if (typeof indexerAsset === "string") {
    params.set("asset", indexerAsset);
    return;
  }

  if (indexerAsset.mint) params.set("mint", indexerAsset.mint);
  if (indexerAsset.asset) params.set("asset", indexerAsset.asset);
}
